import React from 'react'
import { browserHistory } from 'react-router'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ThemeProvider } from 'styled-components'
import BoltTheme from '@boltui/bolt'

import '../utils/findIndexShim'

import { ArgosHeader } from '@boltui/header-fetcher'
import BackToTop from '@argos/back-to-top'
import LiveChat from '@sainsburys-tech/live-chat-component'

import * as actions from '../actions'
import {
  updateDigitalData,
  pushEventAndTrack
} from '../helpers/TaggingSerializer'
import { getCookie, setCookie } from '../helpers/cookieHelpers'
import getUrlParameter from '../helpers/getUrlParameter'
import scrollToTop from '../utils/scroll'
import Footer from '../components/Footer/Footer'
import ErrorRerenderer from '../components/ErrorRerenderer/ErrorRerenderer'
import ErrorBoundary from '../components/ErrorBoundary/ErrorBoundary'
import LoadingBar from '@argos/loading-bar'

import './App.scss'

class App extends React.Component {
  constructor () {
    super()
    this.onUserInfoLoad = this.onUserInfoLoad.bind(this)
  }

  componentWillReceiveProps (newProps) {
    if (this.props.location.pathname !== newProps.location.pathname) {
      scrollToTop()
    }
  }

  onUserInfoLoad (userInfo) {
    updateDigitalData(userInfo, 'HelpFaq Initial Load')
  }

  componentDidMount () {
    if (getUrlParameter('appWebView') === 'true') {
      if (!getCookie('appWebView')) {
        setCookie('appWebView', true, 9999)
      }
      window.digitalData.appWebView = true
      document.body.className += ' appWebView'
    } else if (getCookie('appWebView') === 'true') {
      window.digitalData.appWebView = true
      document.body.className += ' appWebView'
    }
  }

  handleHelpRoute (analyticsPath) {
    pushEventAndTrack({
      eventInfo: {
        eventName: 'header_clickOrigin',
        eventAction: 'header clickorigin'
      }
    })

    window.digitalData.page.attributes.clickorigin = analyticsPath

    browserHistory.push(`/help?clickOrigin=${analyticsPath}`)
  }

  canUseDOM () {
    return !!(
      typeof window !== 'undefined' &&
      window.document &&
      window.document.createElement
    )
  }

  handleMinimized = () => this.props.actions.setChatMinimized({ chatIsMinimized: true })

  handleEnd = () => this.props.actions.setChatEnded({ chatHasEnded: true, chatIsMinimized: false, chatReset: false })

  render () {
    const {
      chatIsHidden,
      chatIsMinimized,
      chatReset,
      actions: {
        saveLiveChatStatus
      }
    } = this.props

    return (
      <ThemeProvider theme={BoltTheme}>
        <div>
          <LoadingBar loading={this.props.loading} loadingColor='mauve' />
          <ErrorRerenderer retries={10}>
            <div>
              <ArgosHeader
                skipToContentTag={'#helpfaqcontent'}
                onSearchSubmit={this.handleSearch}
                onUserInfoLoad={this.onUserInfoLoad}
                routes={{
                  help: analyticsPath => this.handleHelpRoute(analyticsPath)
                }}
              />
            </div>
          </ErrorRerenderer>
          <ErrorBoundary>
            <div className='container-fluid'>{this.props.children}</div>
          </ErrorBoundary>
          <div className='bolt-v2'>
            <ErrorBoundary>
              <LiveChat
                brand='ARGOS'
                department='SERVICE'
                hidden={chatIsHidden}
                minimized={chatIsMinimized}
                onEnd={this.handleEnd}
                onMinimized={this.handleMinimized}
                onSetCmcStatus={saveLiveChatStatus}
                reset={chatReset}
              />
            </ErrorBoundary>
          </div>
          <BackToTop />
          <div className='bolt-v2'>
            <Footer />
          </div>
          <div id='conversocial' className='fb-customerchat' />
        </div>
      </ThemeProvider>
    )
  }
}

App.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  loading: PropTypes.bool,
  location: PropTypes.object,
  actions: PropTypes.object,
  chatIsHidden: PropTypes.bool,
  chatIsMinimized: PropTypes.bool,
  chatReset: PropTypes.bool
}

App.defaultProps = {
  chatIsHidden: true,
  chatIsMinimized: false,
  chatReset: false
}

function mapStateToProps (state) {
  return {
    chatIsHidden: state.page.chatIsHidden,
    chatIsMinimized: state.page.chatIsMinimized,
    chatReset: state.page.chatReset,
    loading:
      state.page.pageLoading ||
      state.help.loading ||
      state.faq.faqLoading ||
      state.faq.searchLoading
  }
}

function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App)

// export default App
